<template>
  <div class="cal-wrapper">
    <div class="cal-header">
      <div class="l cal-nav" @click="preMonth"><div class="arrow-left icon">&nbsp;</div></div>
      <div class="title">{{curYearMonth}}</div>
      <div class="r cal-nav" @click="nextMonth"><div class="arrow-right icon">&nbsp;</div></div>
    </div>
    <div class="cal-body">
      <div class="weeks">
        <span
          v-for="(dayName, dayIndex) in i18n[calendarOptions.options.locale].dayNames"
          class="item"
          :key="dayIndex"
          >
          {{i18n[calendarOptions.options.locale].dayNames[(dayIndex + calendarOptions.options.weekStartOn) % 7]}}
        </span>
      </div>
      <div class="dates" >
        <div v-for="date in dayList" class="item"
          :class="[{
            today: date.status ? (today == date.date) : false,
            event: date.status ? (date.title != undefined) : false,
            [calendarOptions.options.className] : (date.date == selectedDay)
          }, ...date.customClass]"
          :key="date.date"
          >
          <p class="date-num"
            @click="handleChangeCurday(date)"
            :style="{color: date.title != undefined ? ((date.date == selectedDay) ? '#fff' : customColor) : 'inherit'}">
            {{date.status ? date.date.split('/')[2] : '&nbsp;'}}</p>
          <span v-if="date.status ? (today == date.date) : false" class="is-today" :style="{backgroundColor: customColor }" ></span>
          <span v-if="date.status ? (date.title != undefined) : false" class="is-event"
            :style="{borderColor: customColor, backgroundColor: (date.date == selectedDay) ? customColor : 'inherit'}"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import i18n from '../i18n.js'
import { mapState } from 'vuex'
import { dateTimeFormatter, isEqualDateStr } from '../tools.js'

const inBrowser = typeof window !== 'undefined'
const dateObj = new Date()
const DEFAULT_OPTION = {
  locale: 'en', // en
  color: ' #f29543',
  className: 'selected-day',
  weekStartOn: 0 // 0 mean sunday
}

const calendarOptions = Object.assign(DEFAULT_OPTION, {})

const VueCalendarBarEventBus = new Vue({
  data: {
    CALENDAR_EVENTS_DATA: {
      options: calendarOptions,
      params: {
        curYear: dateObj.getFullYear(),
        curMonth: dateObj.getMonth(),
        curDate: dateObj.getDate(),
        curEventsDate: 'all'
      }
    }
  }
})

let Calendar = {
  $vm: null,
  bindEventBus (vm) {
    this.$vm = vm
  },
  toDate (dateString) {
    if (dateString === 'all') {
      this.$vm.CALENDAR_EVENTS_DATA.params = {
        curYear: dateObj.getFullYear(),
        curMonth: dateObj.getMonth(),
        curDate: dateObj.getDate(),
        curEventsDate: 'all'
      }
    } else {
      let dateArr = dateString.split('/')
      dateArr = dateArr.map((item) => {
        return parseInt(item, 10)
      })
      this.$vm.CALENDAR_EVENTS_DATA.params = {
        curYear: dateArr[0],
        curMonth: dateArr[1] - 1,
        curDate: dateArr[2],
        curEventsDate: dateString
      }
    }
  },
  nextMonth () {
    if (this.$vm.CALENDAR_EVENTS_DATA.params.curMonth < 11) {
      this.$vm.CALENDAR_EVENTS_DATA.params.curMonth++
    } else {
      this.$vm.CALENDAR_EVENTS_DATA.params.curYear++
      this.$vm.CALENDAR_EVENTS_DATA.params.curMonth = 0
    }
  },
  preMonth () {
    if (this.$vm.CALENDAR_EVENTS_DATA.params.curMonth > 0) {
      this.$vm.CALENDAR_EVENTS_DATA.params.curMonth--
    } else {
      this.$vm.CALENDAR_EVENTS_DATA.params.curYear--
      this.$vm.CALENDAR_EVENTS_DATA.params.curMonth = 11
    }
  }
}

Vue.prototype.$EventCalendar = Calendar

if (inBrowser) {
  window.VueCalendarBarEventBus = VueCalendarBarEventBus
  Calendar.bindEventBus(VueCalendarBarEventBus)
}

export default {
  name: 'CalendarEvent',
  data () {
    return {
      i18n
    }
  },
  props: {
    selectedDay: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapState(['broadcastForAMonth']),
    calendarOptions () {
      if (inBrowser) {
        return window.VueCalendarBarEventBus.CALENDAR_EVENTS_DATA
      } else {
        return {
          options: {
            locale: 'en', // zh
            color: ' #f29543'
          },
          params: {
            curYear: dateObj.getFullYear(),
            curMonth: dateObj.getMonth(),
            curDate: dateObj.getDate(),
            curEventsDate: 'all'
          }
        }
      }
    },
    dayList () {
      let firstDay = new Date(this.calendarOptions.params.curYear, this.calendarOptions.params.curMonth, 1)
      let dayOfWeek = firstDay.getDay()
      // 根据当前日期计算偏移量 // Calculate the offset based on the current date
      if (this.calendarOptions.options.weekStartOn > dayOfWeek) {
        dayOfWeek = dayOfWeek - this.calendarOptions.options.weekStartOn + 7
      } else {
        dayOfWeek = dayOfWeek - this.calendarOptions.options.weekStartOn
      }

      let startDate = new Date(firstDay)
      startDate.setDate(firstDay.getDate() - dayOfWeek)

      let item
      let status
      let tempArr = []
      let tempItem
      for (let i = 0; i < 42; i++) {
        item = new Date(startDate)
        item.setDate(startDate.getDate() + i)

        if (this.calendarOptions.params.curMonth === item.getMonth()) {
          status = 1
        } else {
          status = 0
        }
        tempItem = {
          date: `${item.getFullYear()}/${item.getMonth() + 1}/${item.getDate()}`,
          status: status,
          customClass: []
        }
        this.broadcastForAMonth.forEach((event) => {
          if (isEqualDateStr(event.date, tempItem.date)) {
            tempItem.title = event.title
            tempItem.desc = event.desc || ''
            if (event.customClass) tempItem.customClass.push(event.customClass)
          }
        })
        tempArr.push(tempItem)
      }
      return tempArr
    },
    today () {
      return `${dateObj.getFullYear()}/${dateObj.getMonth() + 1}/${dateObj.getDate()}`
    },
    curYearMonth () {
      let tempDate = Date.parse(new Date(`${this.calendarOptions.params.curYear}/${this.calendarOptions.params.curMonth + 1}/01`))
      return dateTimeFormatter(tempDate, this.i18n[this.calendarOptions.options.locale].format)
    },
    customColor () {
      return this.calendarOptions.options.color
    }
  },
  methods: {
    nextMonth () {
      this.$EventCalendar.nextMonth()
      this.$emit('month-changed', this.curYearMonth)
    },
    preMonth () {
      this.$EventCalendar.preMonth()
      this.$emit('month-changed', this.curYearMonth)
    },
    handleChangeCurday (date) {
      if (date.status) {
        this.$emit('cur-day-changed', date.date)
      }
    }
  }
}
</script>

<style lang="less">
  @base-orange: #f29543;
  @white: #ffffff;
  @gray: #e0e0e0;
  @gray-dark: #b1b1b1;
  @large-padding: 15px;
  @small-padding: 10px;

  @icon-border-size: 1px;

  @media screen and (min-width: 768px) {
    .cal-wrapper{
      max-width: 1200px;
      margin: 0 auto;
      .date-num{
        line-height: 50px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .cal-wrapper{
      padding: 10px 5px;
      .date-num{
        line-height: 42px;
      }
    }
  }

  .cal-wrapper{
    position: relative;
    overflow: hidden;
    width: 100%;

    p {
      margin: 0;
    }

    .cal-header{
      position: relative;
      font-weight: 500;
      overflow: hidden;
      padding-bottom: 10px;
      &>div{
        float: left;
        line-height: 20px;
        padding: @large-padding;
      }
    }

    .weeks{
      overflow: hidden;
      text-align: center;
      font-size: 1rem;
      .item{
        line-height: 50px;
        float: left;
        width: 100% / 7;
      }
    }
    .dates{
      overflow: hidden;
      text-align: center;
      font-size: 1rem;
      .item{
        position: relative;
        float: left;
        display: block;
        width: 14.285%;
        cursor: default;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        &.event{
          cursor: pointer;
        }
        &.selected-day{
          .is-event{
            background-color: @base-orange;
          }
        }
      }
    }

    .date-num{
      font-size: 1rem;
      position: relative;
      z-index: 3;
    }
    .is-event{
      content: '';
      border: 1px solid @base-orange;
      background-color: #fff;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 1;
      margin-left: -18px;
      margin-top: -19px;
    }
    .is-today{
      content: '';
      background-color: @base-orange;
      opacity: .8;
      width: 12px;
      height: 3px;
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 2;
      margin-left: -6px;
      margin-top: 10px;
    }

    .title{
      width: 60%;
      text-align: center;
    }
    .cal-nav {
      width: 20%;
      cursor: pointer;
      user-select: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
    .l{
      text-align: left;
    }
    .r{
      text-align: right;
    }
    .icon {
      position: absolute;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        top: -5px;
        width: 10px;
        height: 10px;
        border-top: solid @icon-border-size currentColor;
        border-right: solid @icon-border-size currentColor;
      }
    }

    .arrow-left {
      left: 7%;

      &:before {
        left: 1px;
        -webkit-transform: rotate(-135deg);
                transform: rotate(-135deg);
      }
    }
    .arrow-right {
      right: 7%;

      &:before {
        right: 1px;
        -webkit-transform: rotate(45deg);
                transform: rotate(45deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CalendarEvent.vue